import { Component, OnInit } from '@angular/core';
import {AppDatashareservice} from '../app.datashareservice';
import {AppService} from '../app.service';
import {ActivatedRoute} from '@angular/router';
import {LocalStorageService, SessionStorageService} from 'angular-web-storage';
import { environment } from '../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-toollist',
  templateUrl: './toollist.component.html',
  styleUrls: ['./toollist.component.scss']
})
export class ToollistComponent implements OnInit {

  exData: any;
  exId: number;
  toolList: any;

  accessPrivileges: string;

  constructor(
    private _appService: AppService,
    private _appDataService: AppDatashareservice,
    private _route: ActivatedRoute,
    private sessionStorage: SessionStorageService,
    private localStorage: LocalStorageService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {

    this.spinner.show();
    this._appDataService.currentData.subscribe(data => this.exData = data);

    if (this.sessionStorage.get('accessPrivileges')) {
      this.accessPrivileges = this.sessionStorage.get('accessPrivileges');
    } else {
      this.accessPrivileges = environment.appPrivilege;
    }

    if (this._route.snapshot.params.exid) {
      this.exId = this._route.snapshot.params.exid;

      console.log('this.exId::', this.exId);

      this._appService.getToolsByExtensions(this.exId).subscribe(res => {
        this.toolList  = res;
        this.spinner.hide();
      });
    }
  }

}
